import actionTypes from './actionTypes'
import makeUniqueId from 'helpers/makeUniqueId'

const studentActions = {
	checkSlideReady(slide_data, slide_uid) {
		return {
			type: actionTypes.STUDENT_SLIDE_CHECK_READY,
			slide_data,
			slide_uid,
		}
	},
	initializePoll(questionData, session, slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_POLL,
			questionData,
			session,
			slide,
			slide_uid,
		}
	},
	initializePollWithData(questionData, session, slide, slide_uid, answers) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_POLL_WITH_DATA,
			questionData,
			session,
			slide,
			slide_uid,
			answers,
		}
	},
	updatePollAnswer(answers, slide_uid) {
		return {
			type: actionTypes.STUDENT_UPDATE_POLL_ANSWERS,
			answers,
			slide_uid,
		}
	},
	submitPollAnswer(slide_data, slide_uid, sessionType, shouldEnforceSubmission) {
		return {
			type: actionTypes.STUDENT_SUBMIT_POLL_ANSWERS,
			slide_data,
			slide_uid,
			sessionType,
			shouldEnforceSubmission,
		}
	},
	studentSubmitPollConfirm() {
		return {
			type: actionTypes.STUDENT_SUBMIT_POLL_CONFIRM,
		}
	},
	studentSubmitPollConfirmed(slide_data, isAutoSubmit, slide_uid, sessionType) {
		return {
			type: actionTypes.STUDENT_SUBMIT_POLL_CONFIRMED,
			slide_data,
			isAutoSubmit,
			slide_uid,
			sessionType,
		}
	},
	studentSubmitPollEdit() {
		return {
			type: actionTypes.STUDENT_SUBMIT_POLL_EDIT,
		}
	},
	studentSubmitPollCancel() {
		return {
			type: actionTypes.STUDENT_SUBMIT_POLL_CANCEL,
		}
	},
	studentSubmitPollReview() {
		return {
			type: actionTypes.STUDENT_SUBMIT_POLL_REVIEW,
		}
	},
	studentPollEnded(slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_POLL_ENDED,
			slide,
			slide_uid,
		}
	},
	studentPollNavigateBack() {
		return {
			type: actionTypes.STUDENT_POLL_NAVIGATE_BACK,
		}
	},
	studentTimerPollEnded(slide_data, slide_uid) {
		return {
			type: actionTypes.STUDENT_TIMER_POLL_ENDED,
			slide_data,
			slide_uid,
		}
	},
	initializeQuiz(questionData, session, slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_QUIZ,
			questionData,
			session,
			slide,
			slide_uid,
		}
	},
	initializeQuizWithData(questionData, session, slide, slide_uid, answers) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_QUIZ_WITH_DATA,
			questionData,
			session,
			slide,
			slide_uid,
			answers,
		}
	},
	updateQuizAnswer(answers, questionIndex, slide_uid) {
		return {
			type: actionTypes.STUDENT_QUIZ_UPDATE_ANSWERS,
			answers,
			questionIndex,
			slide_uid,
		}
	},
	submitQuiz(slide_data, slide_uid, sessionType, shouldEnforceSubmission) {
		return {
			type: actionTypes.STUDENT_QUIZ_SUBMIT_QUIZ,
			slide_data,
			slide_uid,
			sessionType,
			shouldEnforceSubmission,
		}
	},
	changeQuizSlide(slide_data, direction, slide_uid) {
		return {
			type: actionTypes.STUDENT_QUIZ_CHANGE_SLIDE,
			slide_data,
			direction,
			slide_uid,
		}
	},
	navigateToQuizSlide(slide_data, direction, slide_uid) {
		return {
			type: actionTypes.STUDENT_QUIZ_NAVIGATE_TO_SLIDE,
			slide_data,
			direction,
			slide_uid,
		}
	},
	studentSubmitQuizConfirm() {
		return {
			type: actionTypes.STUDENT_SUBMIT_QUIZ_CONFIRM,
		}
	},
	studentSubmitQuizConfirmed(slide_data, isAutoSubmit, slide_uid, sessionType) {
		return {
			type: actionTypes.STUDENT_SUBMIT_QUIZ_CONFIRMED,
			slide_data,
			isAutoSubmit,
			slide_uid,
			sessionType,
		}
	},
	studentSubmitQuizEdit() {
		return {
			type: actionTypes.STUDENT_SUBMIT_QUIZ_EDIT,
		}
	},
	studentSubmitQuizCancel(slide_uid) {
		return {
			type: actionTypes.STUDENT_SUBMIT_QUIZ_CANCEL,
			slide_uid,
		}
	},
	studentSubmitQuizReview(slide_uid) {
		return {
			type: actionTypes.STUDENT_SUBMIT_QUIZ_REVIEW,
			slide_uid,
		}
	},
	studentQuizEnded(slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_QUIZ_ENDED,
			slide,
			slide_uid,
		}
	},
	studentQuizFirstSlideReached() {
		return {
			type: actionTypes.STUDENT_QUIZ_FIRST_SLIDE_REACHED,
		}
	},
	studentQuizSkipActivity() {
		return {
			type: actionTypes.STUDENT_SKIP_QUIZ,
		}
	},
	studentTimerQuizEnded(slide_data, slide_uid) {
		return {
			type: actionTypes.STUDENT_TIMER_QUIZ_ENDED,
			slide_data,
			slide_uid,
		}
	},
	statusUpdated(status_data) {
		return {
			type: actionTypes.STUDENT_STATUS_UPDATED,
			status_data,
		}
	},
	timerUpdated(timer, slide_uid) {
		return {
			type: actionTypes.STUDENT_TIMER_UPDATED,
			timer,
			slide_uid,
		}
	},
	initializeOeq(activity, session, slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_OEQ,
			questionData: activity,
			session,
			slide,
			slide_uid,
		}
	},
	initializeOeqWithData(questionData, session, slide, slide_uid, answers, audio) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_OEQ_WITH_DATA,
			questionData,
			session,
			slide,
			slide_uid,
			answers,
			audio,
		}
	},
	updateOeqAnswer(answer, slide_uid) {
		return {
			type: actionTypes.STUDENT_UPDATE_OEQ_ANSWER,
			answer,
			slide_uid,
		}
	},
	submitOeqAnswer(slide_data, slide_uid, sessionType, shouldEnforceSubmission) {
		return {
			type: actionTypes.STUDENT_SUBMIT_OEQ_ANSWER,
			slide_data,
			slide_uid,
			sessionType,
			shouldEnforceSubmission,
		}
	},
	studentSubmitOeqConfirm() {
		return {
			type: actionTypes.STUDENT_SUBMIT_OEQ_CONFIRM,
		}
	},
	studentSubmitOeqConfirmed(slide_data, isAutoSubmit, slide_uid, sessionType) {
		return {
			type: actionTypes.STUDENT_SUBMIT_OEQ_CONFIRMED,
			slide_data,
			isAutoSubmit,
			slide_uid,
			sessionType,
		}
	},
	studentSubmitOeqEdit() {
		return {
			type: actionTypes.STUDENT_SUBMIT_OEQ_EDIT,
		}
	},
	studentSubmitDrawitEdit() {
		return {
			type: actionTypes.STUDENT_SUBMIT_DRAWIT_EDIT,
		}
	},
	studentSubmitOeqCancel() {
		return {
			type: actionTypes.STUDENT_SUBMIT_OEQ_CANCEL,
		}
	},
	studentSubmitOeqReview() {
		return {
			type: actionTypes.STUDENT_SUBMIT_OEQ_REVIEW,
		}
	},
	studentOeqEnded(slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_OEQ_ENDED,
			slide,
			slide_uid,
		}
	},
	studentOeqNavigateBack() {
		return {
			type: actionTypes.STUDENT_OEQ_NAVIGATE_BACK,
		}
	},
	studentTimerOeqEnded(slide_data, slide_uid) {
		return {
			type: actionTypes.STUDENT_TIMER_OEQ_ENDED,
			slide_data,
			slide_uid,
		}
	},
	studentTimerStarted() {
		return {
			type: actionTypes.STUDENT_TIMER_STARTED,
		}
	},
	openReferenceMedia() {
		return {
			type: actionTypes.OPEN_REFERENCE_MEDIA,
		}
	},
	closeReferenceMedia() {
		return {
			type: actionTypes.CLOSE_REFERENCE_MEDIA,
		}
	},
	initializeDrawIt(activity, session, slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_DRAW_IT,
			questionData: activity,
			session,
			slide,
			slide_uid,
		}
	},
	initializeDrawItWithData(questionData, session, slide, slide_uid, actions) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_DRAW_IT_WITH_DATA,
			questionData,
			session,
			slide,
			slide_uid,
			actions,
		}
	},
	studentDrawItEnded(slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_DRAW_IT_ENDED,
			slide,
			slide_uid,
		}
	},
	studentSubmitDrawItConfirmed(slide_data,
		isAutoSubmit,
		slide_uid,
		sessionType,
		sessionUid,
		shouldEnforceSubmission) {
		return {
			type: actionTypes.STUDENT_SUBMIT_DRAWIT_CONFIRMED,
			slide_data,
			isAutoSubmit,
			slide_uid,
			sessionType,
			sessionUid,
			shouldEnforceSubmission,
		}
	},
	updateDrawItAnswer(answers, slide_uid, slide_data, session) {
		return {
			type: actionTypes.STUDENT_UPDATE_DRAW_IT_ANSWERS,
			answers,
			slide_uid,
			slide_data,
			session,
		}
	},
	studentTimerDrawItEnded(slide_data, slide_uid) {
		return {
			type: actionTypes.STUDENT_TIMER_DRAW_IT_ENDED,
			slide_data,
			slide_uid,
		}
	},
	confirmDrawItReview() {
		return {
			type: actionTypes.STUDENT_DRAW_IT_REVIEW_CONFIRMED,
		}
	},
	studentDeleteAudioOeqConfirm() {
		return {
			type: actionTypes.STUDENT_DELETE_AUDIO_OEQ_CONFIRM,
		}
	},
	studentDeleteAudioOeqConfirmed(recordedAudio) {
		return {
			type: actionTypes.STUDENT_DELETE_AUDIO_OEQ_CONFIRMED,
			recordedAudio,
		}
	},
	studentDeleteAudioOeqConfirmCancel() {
		return {
			type: actionTypes.STUDENT_DELETE_AUDIO_OEQ_CONFIRM_CANCEL,
		}
	},
	studentSaveRecordedAudio(recordedAudio) {
		return {
			type: actionTypes.STUDENT_SAVE_RECORDED_AUDIO_OEQ,
			recordedAudio,
		}
	},
	studentSubmissionFailed(error, slide_uid, sessionType) {
		return {
			type: actionTypes.STUDENT_SUBMIT_FAILED,
			error,
			slide_uid,
			sessionType,
		}
	},
	studentMatchingPairsSubmissionFailed(error, slide_uid, sessionType) {
		return {
			type: actionTypes.MATCHING_PAIRS_STUDENT_SUBMIT_FAILED,
			error,
			slide_uid,
			sessionType,
		}
	},
	studentSubmissionFailedGotIt() {
		return {
			type: actionTypes.STUDENT_SUBMIT_FAILED_GOT_IT,
		}
	},
	studentRequestMicPermission() {
		return {
			type: actionTypes.STUDENT_REQUEST_MIC_PERMISSION,
		}
	},
	studentRequestMicPermissionCancel() {
		return {
			type: actionTypes.STUDENT_REQUEST_MIC_PERMISSION_CANCEL,
		}
	},
	studentDrawItOnFilesPickerError(msg) {
		return {
			type: actionTypes.STUDENT_DRAW_IT_UNSUPPORTED_FILE_ERROR,
			msg,
		}
	},
	studentOEQRecordingStart(slide_uid) {
		return {
			type: actionTypes.STUDENT_OEQ_RECORDING_START,
			slide_uid,
		}
	},
	studentOEQRecordingUpdate(chunks, slide_uid) {
		return {
			id: makeUniqueId(),
			type: actionTypes.STUDENT_OEQ_RECORDING_UPDATE,
			chunks,
			slide_uid,
		}
	},
	studentOEQRecordingEnd(slide_uid) {
		return {
			type: actionTypes.STUDENT_OEQ_RECORDING_END,
			slide_uid,
		}
	},

	studentOEQRecordingDelete(slide_uid) {
		return {
			type: actionTypes.STUDENT_OEQ_RECORDING_DELETE,
			slide_uid,
		}
	},

	recordingSubmissionSuccess(uid, clientUid, slide_uid) {
		return {
			type: actionTypes.STUDENT_OEQ_RECORDING_SUBMISSION_SUCCESS,
			uid,
			clientUid,
			slide_uid,
		}
	},

	recordingSubmissionFailed(clientUid, slide_uid) {
		return {
			type: actionTypes.STUDENT_OEQ_RECORDING_SUBMISSION_FAILED,
			clientUid,
			slide_uid,
		}
	},

	initializeReadOnly(content, session, slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_READ_ONLY,
			content,
			session,
			slide,
			slide_uid,
		}
	},

	initializeLead(session, slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_LEAD,
			session,
			slide,
			slide_uid,
		}
	},

	initializeLeadWithData(
		session,
		slide,
		slide_uid,
		name,
		optionalName,
		lastNicknameUserLoggedSigned
	) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_LEAD_WITH_DATA,
			session,
			slide,
			slide_uid,
			name,
			optionalName,
			lastNicknameUserLoggedSigned,
		}
	},

	initializeLeadFailed(error) {
		return {
			type: actionTypes.STUDENT_INITIALIZE_LEAD_FAILED,
			error,
		}
	},

	leadSubmit(slide_uid, sessionType, ltiLisResult, newJwt) {
		return {
			type: actionTypes.STUDENT_LEAD_SUBMIT,
			slide_uid,
			sessionType,
			ltiLisResult,
			newJwt,
		}
	},

	leadSubmitSuccess(sessionType, presentation_uid, session_uid, data, slide_uid) {
		return {
			type: actionTypes.STUDENT_LEAD_SUBMIT_SUCCESS,
			sessionType,
			presentation_uid,
			session_uid,
			data,
			slide_uid,
		}
	},

	leadSubmitFailed(
		sessionType,
		presentation_uid,
		session_uid,
		error,
		slide_uid,
	) {
		return {
			type: actionTypes.STUDENT_LEAD_SUBMIT_FAILED,
			sessionType,
			presentation_uid,
			session_uid,
			data: error,
			slide_uid,
		}
	},

	leadEnded(slide, slide_uid) {
		return {
			type: actionTypes.STUDENT_LEAD_ENDED,
			slide,
			slide_uid,
		}
	},

	leadFieldChange(field, value, slide_uid) {
		return {
			type: actionTypes.STUDENT_LEAD_FIELD_CHANGE,
			field,
			value,
			slide_uid,
		}
	},

	readOnlyNavigation(link, slide_uid) {
		return {
			type: actionTypes.READ_ONLY_NAVIGATE,
			link,
			slide_uid,
		}
	},

	leadGoogleLoginSuccess(tokenData) {
		return {
			type: actionTypes.STUDENT_LEAD_GOOGLE_LOGIN_SUCCESS,
			tokenData,
		}
	},

	leadGoogleLoginFailed(error) {
		return {
			type: actionTypes.STUDENT_LEAD_GOOGLE_LOGIN_FAILED,
			error,
		}
	},

	submitLeadGoogleTokenSuccess(data) {
		return {
			type: actionTypes.STUDENT_SUBMIT_LEAD_GOOGLE_TOKEN_SUCCESS,
			data,
		}
	},

	submitLeadGoogleTokenFailed(error) {
		return {
			type: actionTypes.STUDENT_SUBMIT_LEAD_GOOGLE_TOKEN_FAILED,
			error,
		}
	},

	leadOffice365LoginSuccess(tokenData) {
		return {
			type: actionTypes.STUDENT_LEAD_OFFICE_365_LOGIN_SUCCESS,
			tokenData,
		}
	},

	leadOffice365LoginFailed(error) {
		return {
			type: actionTypes.STUDENT_LEAD_OFFICE_365_LOGIN_FAILED,
			error,
		}
	},

	submitLeadOffice365TokenSuccess(data) {
		return {
			type: actionTypes.STUDENT_SUBMIT_LEAD_OFFICE_365_TOKEN_SUCCESS,
			data,
		}
	},

	submitLeadOffice365TokenFailed(error) {
		return {
			type: actionTypes.STUDENT_SUBMIT_LEAD_OFFICE_365_TOKEN_FAILED,
			error,
		}
	},

	leadGoogleGetNameSuccess(profileData) {
		return {
			type: actionTypes.STUDENT_LEAD_GOOGLE_GET_NAME_SUCCESS,
			profileData,
		}
	},

	leadGoogleGetNameFailed(error) {
		return {
			type: actionTypes.STUDENT_LEAD_GOOGLE_GET_NAME_FAILED,
			error,
		}
	},

	leadOffice365GetNameSuccess(profileData) {
		return {
			type: actionTypes.STUDENT_LEAD_OFFICE_365_GET_NAME_SUCCESS,
			profileData,
		}
	},

	leadOffice365GetNameFailed(error) {
		return {
			type: actionTypes.STUDENT_LEAD_OFFICE_365_GET_NAME_FAILED,
			error,
		}
	},
}

export default studentActions
